/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uploading_ShotsInputs */

const en_uploading_shots = /** @type {(inputs: Uploading_ShotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploading shot change data...`)
};

const fr_uploading_shots = /** @type {(inputs: Uploading_ShotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement des données de changement de plan...`)
};

const de_uploading_shots = /** @type {(inputs: Uploading_ShotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schusswechseldaten werden hochgeladen...`)
};

const it_uploading_shots = /** @type {(inputs: Uploading_ShotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento dei dati relativi al cambio di inquadratura...`)
};

const ru_uploading_shots = /** @type {(inputs: Uploading_ShotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка данных об изменении кадра...`)
};

const es_uploading_shots = /** @type {(inputs: Uploading_ShotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando datos de cambio de toma...`)
};

const zh_cn2_uploading_shots = /** @type {(inputs: Uploading_ShotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在上传镜头切换数据……`)
};

const ja_uploading_shots = /** @type {(inputs: Uploading_ShotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショット変更データをアップロードしています...`)
};

const hi_uploading_shots = /** @type {(inputs: Uploading_ShotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉट परिवर्तन डेटा अपलोड किया जा रहा है...`)
};

const pt_pt2_uploading_shots = /** @type {(inputs: Uploading_ShotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando dados de alteração de tiro...`)
};

/**
* | output |
* | --- |
* | "Uploading shot change data..." |
*
* @param {Uploading_ShotsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const uploading_shots = /** @type {((inputs?: Uploading_ShotsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uploading_ShotsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_uploading_shots(inputs)
	if (locale === "de") return de_uploading_shots(inputs)
	if (locale === "it") return it_uploading_shots(inputs)
	if (locale === "ru") return ru_uploading_shots(inputs)
	if (locale === "es") return es_uploading_shots(inputs)
	if (locale === "zh-CN") return zh_cn2_uploading_shots(inputs)
	if (locale === "ja") return ja_uploading_shots(inputs)
	if (locale === "hi") return hi_uploading_shots(inputs)
	if (locale === "pt-PT") return pt_pt2_uploading_shots(inputs)
	return en_uploading_shots(inputs)
});